var _defs, _rect, _rect2, _rect3, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _path7, _path8, _path9, _path0, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path1, _polygon5, _polygon6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailOffer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 681.23 528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 356.11,
    y1: 334.19,
    x2: 359.52,
    y2: 446.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 358.8,
    y1: 425.67,
    x2: 362.58,
    y2: 507.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 627.27,
    y1: 374.59,
    x2: 785.85,
    y2: 374.59,
    gradientTransform: "matrix(-1, 0, 0, 1, 1135.56, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ead4d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e9cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 717.16,
    y1: 373.42,
    x2: 853.7,
    y2: 293.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 1135.56, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 743.42,
    y1: 359.53,
    x2: 758.73,
    y2: 258.56,
    gradientTransform: "matrix(-1, 0, 0, 1, 1135.56, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 739.02,
    y1: 361.02,
    x2: 753.36,
    y2: 266.47,
    gradientTransform: "matrix(-1, 0, 0, 1, 1135.56, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 907.02,
    y1: 222.8,
    x2: 789.76,
    y2: 258.36,
    gradientTransform: "matrix(-0.25, -0.97, -0.97, 0.25, 686.74, 1033.88)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 851.51,
    y1: 235.18,
    x2: 916.75,
    y2: 223.83,
    gradientTransform: "matrix(-0.25, -0.97, -0.97, 0.25, 690.55, 1031.33)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 882.05,
    y1: 231.56,
    x2: 831.35,
    y2: 246.93,
    gradientTransform: "matrix(-1, 0, 0, 1, 1135.56, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 721.18,
    y1: 353.7,
    x2: 775.84,
    y2: 353.7,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 675.25,
    y1: 266.2,
    x2: 762.25,
    y2: 383.83,
    gradientTransform: "matrix(-1, 0, 0, 1, 1135.56, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 832.59,
    y1: 237.12,
    x2: 1001.66,
    y2: 242.23,
    gradientTransform: "matrix(-1, 0, 0, 1, 1135.56, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 183.44,
    y1: 121.77,
    x2: 219.09,
    y2: 121.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 122.65,
    y1: 119.45,
    x2: 175.16,
    y2: 119.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 112.05,
    y1: 210.74,
    x2: 160.71,
    y2: 210.74,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "marketing 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M84.65,220.35c-5.67,27.92-5.53,57.07-14.59,84.08C53.74,353.08,9.15,390,.15,440.55-6.42,477.41,9,517.34,38.61,540.23,64.06,559.9,97,566.56,128.84,571.12c119.37,17.1,240.74,12.68,361,4.27,43.83-3.07,89.17-7.11,127.54-28.49,24.38-13.59,45.29-34.45,55.68-60.35s9.23-56.94-6-80.32c-16.75-25.68-49.11-41.91-55.54-71.9-5.48-25.56,10.3-50.13,21.71-73.65,19-39.18,26.4-87.41,5.35-125.52-13-23.51-35.4-40.59-59.46-52.55C511.79,49.15,432.64,52.38,357.77,59.38,249.33,69.53,110.18,94.86,84.65,220.35Z",
    transform: "translate(1.35 -54.82)",
    fill: "#00b7de",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 177.26,
    y: 145.06,
    width: 365.86,
    height: 236.43,
    rx: 19.43,
    fill: "#00b7de"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 186.03,
    y: 154.2,
    width: 345.22,
    height: 223.1,
    rx: 18.34,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.11,
    y: 284.64,
    width: 130.76,
    height: 56.65,
    rx: 15.25,
    fill: "#00b7de",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.38,
    y: 287.53,
    width: 130.76,
    height: 56.65,
    rx: 15.25,
    fill: "#00b7de",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.03,
    y: 158.19,
    width: 130.76,
    height: 56.65,
    rx: 15.25,
    fill: "#00b7de",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 221.4,
    y: 218.93,
    width: 132,
    height: 142.59,
    rx: 14.47,
    fill: "#00b7de",
    opacity: 0.11
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.94,313.9s-2.84,11.34,6.24,17,43.69-9.65,64.68-11.92S349,325.24,349,325.24,341,340,341.6,356.45s1.7,29.5,0,32.34,9.64,14.18,11.34,14.75,17,1.7,17,1.7l19.29,28.37,49.07-1.05-30.16-99.63,14.57-49.1-135-17.59Z",
    transform: "translate(1.35 -54.82)",
    fill: "#00b7de",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "188.98 379.7 120.96 430.91 597.13 430.91 530.63 378.94 188.98 379.7",
    fill: "#00b7de"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.98 379.7 120.96 430.91 597.13 430.91 530.63 378.94 188.98 379.7",
    fill: "url(#linear-gradient)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.45 449.64 120.96 430.91 597.13 430.91 579.55 450.79 140.45 449.64",
    fill: "#00b7de"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.45 449.64 120.96 430.91 597.13 430.91 579.55 450.79 140.45 449.64",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "305.54 422.89 325.8 406.84 399.93 406.45 421.33 422.51 305.54 422.89",
    fill: "#00b7de",
    opacity: 0.58,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.52 403.91 549.74 403.4 529.11 386.58 188.22 386.58 164.52 403.91",
    fill: "#00b7de",
    opacity: 0.58,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M399.5,405.39c-2.22-3-6.13-4.18-9.64-5.52-13.74-5.28-24.57-16.07-34.19-27.19-2.23-2.57-4.47-5.27-5.45-8.53a12.82,12.82,0,0,1,2.38-11.68,15.37,15.37,0,0,0,1.48-1.87,10.14,10.14,0,0,0,1-3.22c.67-3.34,2.23-7.16,5.57-7.84a10.9,10.9,0,0,0,2.22-.43c1.2-.53,1.78-1.87,2.3-3.08,1.93-4.46,5.13-9.13,9.95-9.73a4.54,4.54,0,0,0,1.8-.39c1.34-.77,1.16-2.7,1.46-4.22.74-3.79,5.4-5.72,9.18-4.91s6.82,3.53,9.67,6.13l10.94,10c2.94,2.68,6,5.47,9.93,6.41a2.6,2.6,0,0,0,2-.12,3,3,0,0,0,1-2.21c1.37-8.42,16.31-17.72,22.84-16.59-4,11.35-7.12,29.27-9.46,45.7,11.11,18.36,27.64,32.21,44.43,45.58A118.15,118.15,0,0,0,492,421.2c5.45,3.24,11.45,5.64,16.29,9.73l-70,1.63a15.79,15.79,0,0,1-5.78-.57,15.62,15.62,0,0,1-4.88-3.27q-10-8.7-19.41-18C406,408.56,402.56,406.17,399.5,405.39Z",
    transform: "translate(1.35 -54.82)",
    fill: "url(#linear-gradient-3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M415.79,354.74c-.72,6.07-4,11.53-7.58,16.46A42,42,0,0,1,399,381a19.13,19.13,0,0,1-12.68,3.83,15,15,0,0,1-9.76-5,7.15,7.15,0,0,1-1.79-3.29c-.53-2.85,1.59-5.44,3.6-7.53a250,250,0,0,1,23.91-21.87c2.62-2.1,9.87-8.32,13.69-6.85C417.82,341,416.14,351.75,415.79,354.74Z",
    transform: "translate(1.35 -54.82)",
    fill: "url(#linear-gradient-4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M436.82,315l-63,81.14s-16.45-1.14-26.67-9.65,7.95-13.62,7.95-13.62,37.44-37.44,42.55-66.95Z",
    transform: "translate(1.35 -54.82)",
    fill: "#00b7de"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.14,386.48c4.75,3.95,10.72,6.29,15.8,7.66a59.47,59.47,0,0,0,10.88,2l62-79.71,1.05-1.37L397.68,306c-5.08,29.5-42.56,67-42.56,67S337,378,347.14,386.48Z",
    transform: "translate(1.35 -54.82)",
    fill: "url(#linear-gradient-5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357.37,390.51a27.73,27.73,0,0,0,5.57,3.63,59.47,59.47,0,0,0,10.88,2l62-79.71-27.89-6.53c-5.16,29.5-42.56,67-42.56,67S347.14,382,357.37,390.51Z",
    transform: "translate(1.35 -54.82)",
    fill: "url(#linear-gradient-6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M481.66,268.17a30.84,30.84,0,0,0-19.93-15.43C422.41,243.27,299.28,209,292.14,149.93c0,0-2.27-15.32-21.56-15.32S220.65,317.3,225.76,321.27s22.69-4.54,31.77-13,34.61-26.1,69.22-15.32c15.57,4.85,43.93,11.43,70.41,17.19,19,4.14,37.06,7.86,48.72,10.22A27.33,27.33,0,0,0,472.31,311c7.25-8.66,14.29-21.79,11.6-38.55C483.91,272.48,483,270.67,481.66,268.17Z",
    transform: "translate(1.35 -54.82)",
    fill: "#00b7de"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.24,
    cy: 227.87,
    rx: 95.69,
    ry: 32.24,
    transform: "translate(-34.96 354.13) rotate(-75.64)",
    fill: "#00b7de"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.24,
    cy: 227.87,
    rx: 95.69,
    ry: 32.24,
    transform: "translate(-34.96 354.13) rotate(-75.64)",
    fill: "url(#linear-gradient-7)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.79,
    cy: 229.05,
    rx: 28.79,
    ry: 9.7,
    transform: "translate(-33.44 358.45) rotate(-75.64)",
    fill: "url(#linear-gradient-8)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M255.93,201.15l24.58,3.25s-9.36,59.57-19.86,64.68l-16.74-12.49Z",
    transform: "translate(1.35 -54.82)",
    fill: "url(#linear-gradient-9)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M397.84,332.93c3.49,2.93,7.57,5.05,11.34,7.59,2.47,1.66,5,3.89,5.19,6.87a8.46,8.46,0,0,1-1.14,4.22,22.21,22.21,0,0,1-5.43,6.86c-1.8,1.53-3.86,2.79-5.37,4.61a32.86,32.86,0,0,0-2.62,4.14c-2.72,4.48-6.62,8.1-10.47,11.66a23.39,23.39,0,0,1-3.51,2.85,14.24,14.24,0,0,1-12.32.91,22.08,22.08,0,0,1-9.88-7.85c-2.62-3.54-4.5-8-3.75-12.29a20.72,20.72,0,0,1,3.25-7.26,147.22,147.22,0,0,1,17.2-22.42c1.65-1.76,7.33-9.38,9.95-9C392.26,324.06,395.79,331.21,397.84,332.93Z",
    transform: "translate(1.35 -54.82)",
    fill: "url(#linear-gradient-10)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M426,279.1s-6.69,30.21-28.88,31l55,12.51s19.66-1.14,23.45-9.08S499,278,471.43,256.4l-44.26-13.61S432.09,260.94,426,279.1Z",
    transform: "translate(1.35 -54.82)",
    fill: "url(#linear-gradient-11)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M295.54,170.92S302,242,260.74,304.82c0,0,24.59-18.91,54.47-14.75,0,0,16.27-59.76,9.08-76.41S295.54,170.92,295.54,170.92Z",
    transform: "translate(1.35 -54.82)",
    fill: "url(#linear-gradient-12)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 422.77,
    y: 40.22,
    width: 209.56,
    height: 90.79,
    rx: 24.45,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 500.09,
    y: 150.96,
    width: 130.76,
    height: 56.65,
    rx: 15.25,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 268.86,
    y: 15.83,
    width: 130.76,
    height: 56.65,
    rx: 15.25,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 78.09,
    y: 278.86,
    width: 130.76,
    height: 56.65,
    rx: 15.25,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 499.13,
    y: 279.83,
    width: 130.76,
    height: 56.65,
    rx: 15.25,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 450.23,
    y: 55.86,
    width: 156.81,
    height: 6.5,
    rx: 3.25,
    fill: "#00b7de",
    opacity: 0.11
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 450.23,
    y: 78.27,
    width: 156.81,
    height: 6.5,
    rx: 3.25,
    fill: "#00b7de",
    opacity: 0.11
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 518.88,
    y: 163.53,
    width: 96.83,
    height: 6.5,
    rx: 2.56,
    fill: "#00b7de",
    opacity: 0.11
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 518.88,
    y: 185.93,
    width: 96.83,
    height: 6.5,
    rx: 2.56,
    fill: "#00b7de",
    opacity: 0.11
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 518.88,
    y: 292.16,
    width: 96.83,
    height: 6.5,
    rx: 2.56,
    fill: "#00b7de",
    opacity: 0.11
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 518.88,
    y: 314.56,
    width: 96.83,
    height: 6.5,
    rx: 2.56,
    fill: "#00b7de",
    opacity: 0.11
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 98.32,
    y: 290.71,
    width: 96.83,
    height: 6.5,
    rx: 2.56,
    fill: "#00b7de",
    opacity: 0.11
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 98.32,
    y: 313.11,
    width: 96.83,
    height: 6.5,
    rx: 2.56,
    fill: "#00b7de",
    opacity: 0.11
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 286.2,
    y: 28.65,
    width: 96.83,
    height: 6.5,
    rx: 2.56,
    fill: "#00b7de",
    opacity: 0.11
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 286.2,
    y: 51.05,
    width: 96.83,
    height: 6.5,
    rx: 2.56,
    fill: "#00b7de",
    opacity: 0.11
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 450.23,
    y: 100.67,
    width: 156.81,
    height: 6.5,
    rx: 3.25,
    fill: "#00b7de",
    opacity: 0.11
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M183.44,105.63C184.88,108.52,208,148,208,148l11.08-7.71L207,95.51Z",
    transform: "translate(1.35 -54.82)",
    fill: "url(#linear-gradient-13)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "138.06 99.46 175.16 127.4 167.45 139.45 122.65 125.48 138.06 99.46",
    fill: "url(#linear-gradient-14)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "112.05 203.52 160.22 195.81 160.71 209.78 113.5 225.68 112.05 203.52",
    fill: "url(#linear-gradient-15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOffer);
export default __webpack_public_path__ + "static/media/email_offer.0d25c585bb9f2bc897c4835f42dbf253.svg";
export { ForwardRef as ReactComponent };